import React, { useState } from 'react';

import classNames from 'classnames';
import { useIntl } from 'react-intl';

import IconFemtasy from 'components/IconFemtasy';

interface IProps {
  type: 'email' | 'password' | 'text' | 'date';
  label?: string;
  error?: boolean;
  name: string;
  inputProps: React.InputHTMLAttributes<HTMLInputElement>;
  value?: any;
}

const TextInput = ({ type, label, error, name, inputProps, value }: IProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const { formatMessage } = useIntl();

  const { className: inputClassName, ...restInputProps } = inputProps;

  const labelFloated = 'top-2 text-sm leading-4';
  const labelResting = 'top-4 text-md leading-7';
  const labelPositionClasses =
    type === 'date'
      ? value
        ? labelFloated
        : `${labelResting} peer-focus:top-2 peer-focus:text-sm peer-focus:leading-4`
      : `${labelFloated} peer-placeholder-shown:top-4 peer-placeholder-shown:text-md peer-placeholder-shown:leading-7 peer-focus:top-2 peer-focus:text-sm peer-focus:leading-4`;

  return (
    <div className="relative w-full">
      <input
        aria-invalid={error || undefined}
        className={classNames(
          'peer block w-full appearance-none rounded-2xl border-3 border-solid bg-white font-sans text-md font-semibold leading-7 text-dark-body outline-none placeholder:font-medium placeholder:text-dark-body placeholder:opacity-100',
          type === 'date'
            ? 'px-2 py-3 [&::-webkit-date-and-time-value]:text-left [&::-webkit-date-and-time-value]:mt-2'
            : 'px-4 pb-2 pt-6',
          error
            ? 'TextInput--error border-acid'
            : 'border-soft-sensual-outlines',
          type === 'password' && 'pr-12',
          inputClassName,
        )}
        id={name}
        name={name}
        placeholder=" "
        type={showPassword ? 'text' : type}
        value={value}
        {...restInputProps}
      />
      {label && (
        <label
          className={classNames(
            'pointer-events-none absolute left-4 truncate font-sans font-medium text-dark-body transition-all duration-200',
            labelPositionClasses,
          )}
          htmlFor={name}
        >
          {label}
        </label>
      )}
      {type === 'password' && (
        <button
          aria-label={formatMessage({
            id: showPassword
              ? 'components.PasswordToggle.hidePasswordAriaLabel'
              : 'components.PasswordToggle.showPasswordAriaLabel',
          })}
          className="absolute inset-y-0 right-3 flex cursor-pointer items-center border-0 bg-transparent p-0"
          onClick={() => {
            setShowPassword(!showPassword);
          }}
          type="button"
        >
          <IconFemtasy color="dark-body" icon="Eyeline" />
        </button>
      )}
    </div>
  );
};

export default TextInput;
